import { Component, OnInit } from '@angular/core';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {DialogModel} from '@shared/models/dialog.model';

@Component({
    standalone: false,
    selector: 'app-spreadsheet-search-dialog',
  templateUrl: './spreadsheet-search-dialog.component.html',
  styleUrls: ['./spreadsheet-search-dialog.component.scss']
})
export class SpreadsheetSearchDialogComponent implements OnInit, IDialogView {
  data: DialogModel;

  constructor() { }

  ngOnInit(): void {
  }


  onOkClicked(): any {
  }

}
